import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeftIcon, UsersIcon, MapPinIcon, CalendarIcon, LinkIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import EventCard from '../components/EventCard';
const CommunityProfile = () => {
  const {
    id
  } = useParams();
  // Mock community data
  const community = {
    id,
    name: 'WeRun Nairobi',
    description: 'A community of runners in Nairobi meeting every weekend for group runs and training. We welcome runners of all levels, from beginners to advanced. Join us to improve your fitness, prepare for races, or just meet fellow running enthusiasts.',
    memberCount: 358,
    location: 'Nairobi',
    category: 'Sports & Fitness',
    events: [{
      title: 'Saturday Morning Run',
      date: 'June 15, 2023',
      time: '6:00 AM - 8:00 AM',
      location: 'Karura Forest',
      attendees: 42
    }, {
      title: 'Beginners Training Session',
      date: 'June 18, 2023',
      time: '5:30 PM - 6:30 PM',
      location: 'Uhuru Park',
      attendees: 15,
      maxAttendees: 20
    }],
    admins: ['Jane Muthoni', 'David Ochieng'],
    socialMedia: {
      website: 'werunnairobi.co.ke',
      instagram: '@werunnairobi',
      facebook: 'WeRun Nairobi Group'
    }
  };
  return <div data-id="element-1085">
      <div className="bg-gray-100 p-4" data-id="element-1086">
        <Link to="/" className="inline-block mb-2" data-id="element-1087">
          <ArrowLeftIcon className="w-5 h-5 text-gray-700" data-id="element-1088" />
        </Link>
        <div className="flex items-start justify-between" data-id="element-1089">
          <div className="flex items-center" data-id="element-1090">
            <div className="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center border border-dashed border-gray-400 mr-3" data-id="element-1091">
              <span className="text-gray-500" data-id="element-1092">Logo</span>
            </div>
            <div data-id="element-1093">
              <h1 className="text-xl font-bold" data-id="element-1094">{community.name}</h1>
              <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-1095">
                <UsersIcon className="w-4 h-4 mr-1" data-id="element-1096" />
                <span data-id="element-1097">{community.memberCount} members</span>
              </div>
              <div className="flex items-center mt-1 text-sm text-gray-600" data-id="element-1098">
                <MapPinIcon className="w-4 h-4 mr-1" data-id="element-1099" />
                <span data-id="element-1100">{community.location}</span>
              </div>
            </div>
          </div>
          <button className="bg-gray-800 text-white rounded-md px-4 py-2 text-sm" data-id="element-1101">
            Join
          </button>
        </div>
      </div>
      <div className="p-4" data-id="element-1102">
        <div className="border-b border-gray-200 pb-4 mb-4" data-id="element-1103">
          <h2 className="text-lg font-medium mb-2" data-id="element-1104">About</h2>
          <p className="text-sm text-gray-600" data-id="element-1105">{community.description}</p>
        </div>
        <div className="border-b border-gray-200 pb-4 mb-4" data-id="element-1106">
          <h2 className="text-lg font-medium mb-2" data-id="element-1107">Upcoming Events</h2>
          {community.events.map((event, index) => <EventCard key={index} {...event} data-id="element-1108" />)}
        </div>
        <div className="border-b border-gray-200 pb-4 mb-4" data-id="element-1109">
          <h2 className="text-lg font-medium mb-2" data-id="element-1110">Admins</h2>
          <div className="flex flex-wrap gap-2" data-id="element-1111">
            {community.admins.map((admin, index) => <div key={index} className="flex items-center border border-gray-300 rounded-full px-3 py-1" data-id="element-1112">
                <div className="w-5 h-5 bg-gray-300 rounded-full mr-2" data-id="element-1113"></div>
                <span className="text-sm" data-id="element-1114">{admin}</span>
              </div>)}
          </div>
        </div>
        <div data-id="element-1115">
          <h2 className="text-lg font-medium mb-2" data-id="element-1116">Connect</h2>
          <div className="space-y-2" data-id="element-1117">
            <div className="flex items-center" data-id="element-1118">
              <LinkIcon className="w-5 h-5 text-gray-600 mr-2" data-id="element-1119" />
              <a href="#" className="text-sm underline" data-id="element-1120">
                {community.socialMedia.website}
              </a>
            </div>
            <div className="flex items-center" data-id="element-1121">
              <InstagramIcon className="w-5 h-5 text-gray-600 mr-2" data-id="element-1122" />
              <a href="#" className="text-sm" data-id="element-1123">
                {community.socialMedia.instagram}
              </a>
            </div>
            <div className="flex items-center" data-id="element-1124">
              <FacebookIcon className="w-5 h-5 text-gray-600 mr-2" data-id="element-1125" />
              <a href="#" className="text-sm" data-id="element-1126">
                {community.socialMedia.facebook}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default CommunityProfile;